import { Flows, flows } from '@flows';
import { AppSettingsType, BaseSessionInfo, BaseSessionInfoCompany } from '@types';

import appSettingsAB from './ab/appSettings.json';
import appSettingsBCP from './bcp/appSettings.json';

export * from './envVarsValues';

export const getAppSettings = (sessionInfo: BaseSessionInfo): AppSettingsType => {
	const appSettings = sessionInfo.company === BaseSessionInfoCompany.BCP ? appSettingsBCP : appSettingsAB;

	const flow = sessionInfo.journeyData.flow;

	const res = appSettings.entryPointFlow.hasOwnProperty(flow)
		? (appSettings.entryPointFlow as any)[flow]
		: appSettings.entryPointFlow.default;

	const entryPointFlow: Flows = flows.hasOwnProperty(res) ? (res as Flows) : 'clPublicSimulator';

	return { entryPointFlow, stickyBarStatus: false };
};
